import { PortalHub } from "@/features/portal/components/hub/portal-hub";

/** `/portal/home` — welcome hub linking to the enabled surfaces. */
export default function PortalHomePage() {
  return <PortalHub />;
}
